import cn from "classnames";
import { Field } from "components/shared/form";
import PanelTemplate from "components/shared/profile/panel";
import React, { Fragment } from "react";
import { config, initialState } from "./config";
import OverallMailReportUsers from "./overallMailReportUsers";

class ReportExecutionTimes extends PanelTemplate {
    renderBody = () => {
        const { editable, config } = this.props;
        const { executionTime } = config.executionTimes.config;
        return (
            <Fragment>
                {this.state.data.executionTimes.map((item, i) => (
                    <Fragment key={i}>
                        {this.renderField({
                            ...executionTime,
                            i,
                            disabled: !editable,
                            value: item.executionTime,
                            additionalText: this.removeBtn(i),
                            onChange: (data) => this.setValue(data, i),
                        })}
                    </Fragment>
                ))}
                {this.props.editable && (
                    <div>
                        <div className="inline-btn inline-btn--plus" onClick={this.addTime}>
                            Добавить
                        </div>
                    </div>
                )}
            </Fragment>
        );
    };

    update = () => {
        const { shouldUpdate, data } = this.state;
        if (!this.isValidForm(data)) {
            return this.setState({ isValid: false });
        }

        data.executionTimes.forEach((item) => {
            if (item.executionTime.split(":").length === 2) {
                item.executionTime = `${item.executionTime}:00`;
            }
        });

        if (shouldUpdate) {
            return this.props
                .action(data)
                .then((res) => {
                    if (res) {
                        this.props.update();
                    } else {
                        this.setState({ isValid: false });
                    }
                })
                .then(() => this.setState({ shouldUpdate: false }));
        }
    };

    removeBtn = (i) => {
        const { editable } = this.props;
        if (!editable) {
            return null;
        }
        return <span className="icon-uEA07-delite text-danger cursor-pointer" onClick={() => this.remove(i)} />;
    };

    addTime = () => {
        const { data } = this.state;
        data.executionTimes = [...data.executionTimes, { executionTime: "" }];
        this.setState({ data, shouldUpdate: true });
    };

    remove = (i) => {
        const { data } = this.state;
        data.executionTimes.splice(i, 1);
        this.setState({ data, shouldUpdate: true });
    };

    renderField = (props) => {
        return (
            <Field
                wrapper="panel__row"
                onChange={this.setValue}
                value={this.state.data[props.inputProps.name]}
                labelWrapper="col-form-label col-form-label-sm col-12 text-muted"
                fieldWrapper="col-11"
                bWrapper="row mb-2"
                {...props}
            />
        );
    };

    setValue = ({ value, name }, i) => {
        const executionTimes = this.state.data.executionTimes.map((item, index) =>
            index === i ? { ...item, [name]: value } : item,
        );
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ data: { executionTimes }, shouldUpdate: true, ...(isValid ? { isValid: true } : {}) });
    };

    renderOverallMailReportUsers = () => {
        const { roles, profile, organization, modal } = this.props;
        const canManageMailReportUsers = roles?.isTruckingOrganizationAdmin || roles?.isTruckingOrganizationHeadLogist;

        if (!canManageMailReportUsers) {
            return null;
        }

        return (
            <Fragment>
                <div className="col-12">
                    <hr className="my-3" />
                </div>
                <div className="col-sm-4">
                    <h5>Получатели ежедневного отчета</h5>
                </div>
                <div className="col-sm-8">
                    <OverallMailReportUsers roles={roles} profile={profile} organization={organization} modal={modal} />
                </div>
            </Fragment>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Время отправки ежедневного отчета</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                    {this.renderOverallMailReportUsers()}
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <ReportExecutionTimes {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
